// The payload wraps the identifier in an object: synapse requires a record, never a bare primitive.
export type SubjectTypeRestoredPayload = {
	subjectTypeId: number;
};

export type SubjectTypeRestoredAction = {
	type: 'SUBJECT_TYPE_RESTORED';
	payload: SubjectTypeRestoredPayload;
	accountId: number;
};

export default (payload: SubjectTypeRestoredPayload, accountId: number): SubjectTypeRestoredAction => ({
	type: 'SUBJECT_TYPE_RESTORED',
	payload,
	accountId,
});
